import IDeal from "../interfaces/IDeal";
import useDealsInsideShape from "./useDealsInsideShape";
import useFocusShape from "./useFocusShape";

export default function (deals: IDeal[]): IDeal[] {
    return useDealsInsideShape(deals, useFocusShape());
}